<template lang="html">
  <div class="signatures-container">
     <div
      class="signatures"
      v-if="
        !(
          order.orderState == 10 ||
          (order.refundState == 10 && order.orderState == 50)
        ) &&
        codeList.length > 0 &&
        (channelType != 4 || (channelType == 4 && groupStaus == 2)) && !isSticketDifData
      "
    >
      <!--(不是待支付10 已取消50) 并且 总次数大于0 并且（不是团购 或者 团购必须是团成功的状态）才展示二维码核销的
          channelType //1.正常下单2.一元购3.抢购4.团购5.积分
          smallGroupStatus //小团状态(1-参团中 2团成功 3 团失败 )-->
      <div class="signatures-wrapper signatures-new">
        <div class="title">
          <p>核销</p>
          <!-- <span class="titleTip">核销完成后本平台将向商家支付款项</span> -->
        </div>

        <div class="number">
          <p>
            <span>待核销 </span><span class="count">{{ newCodes().length }}次</span>
          </p>
          <p>
            <span>已核销 </span
            ><span class="count">{{ codeList.length - newCodes().length }}次</span>
          </p>
          <!--三方门票，时间因为不准，所以隐藏-->
          <p class="barcode-user-end-time" v-if="!isThirdParty && showingCode">有效期至 {{ barcodeUseEndTime }}</p>
        </div>
        <!-- ### 异业导码，订单详情页面不显示成长加核销码和条形码,仅显式文描  -->
        <div v-if="showingCode && showingCode.writeoffType && showingCode.writeoffType == 4">请凭手机短信内容验证使用</div>
        <!-- ### 非异业导码 -->
        <template v-else>
              <div class="dialog-qrcode" v-if="isShowBarCode">
                      <!--非三方码串-->
                      <p class="code" v-if="!isThirdParty" >券码：<span id="success_form_input1">{{ showingCode.barcode }}</span>
                          <button
                              @click="copyText"
                              ref="copyCode"
                              :data-clipboard-text="showingCode.barcode"
                              data-clipboard-target="#success_form_input1"
                            class="copyText"
                        >
                            复制
                        </button>
                    </p>
                    <!--三方码串-->
                    <p class="code" v-if="isThirdParty && showingCode.checkNo">券码：<span id="success_form_input2">{{ showingCode.checkNo }}</span>
                        <button
                            @click="copyText"
                            ref="copyCode"
                            :data-clipboard-text="showingCode.checkNo"
                            data-clipboard-target="#success_form_input2"
                            class="copyText"
                        >
                            复制
                        </button>
                    </p>
                    
                    <!-- 二维码区块 -->
                    <div class="swipe-layout" v-if="showSwipe">
                        <p class="prev" @click="prevPage" v-if="newCodes() && newCodes().length > 1">
                            <i class="iconfont icon-youjiantou icon-zuojiatoutou-extra" ></i>
                        </p>
                        <div class="swipe-main">
                            <mt-swipe :auto="0" :showIndicators="false"  @change="handleChange" :defaultIndex="defaultIndex" ref="swipe">
                                <mt-swipe-item v-for="(item, index) in newCodes()" :key="index">
                                    <div class="swipe-item-ui">
                                        <div class="code-barcode">
                                            <!-- 非三方码-->
                                            <qrcode class="qrcode-box" v-if="!isThirdParty && item.barcode" :code="item.barcode" :width="130" :index="item.barcode"></qrcode>

                                            <!-- 三方码-->
                                            <!--保持原方案：即使三方没有返回qrcode，履单系统也会给qrcode赋值'zwy-blank'的值，再交由showImage.do返回兜底图片-->
                                            <img v-else-if="isThirdParty && item.qrCode" :src="`//sorderapi.czj100.com/sorder-api/COrder/showImage.do?path=${encodeURIComponent(item.qrCode)}`" >
                                            
                                            <div v-else class="no-code">
                                                <img src="~@/assets/images/order/loading.gif" >
                                                <p class="no-code-tip">出票中，请稍后下拉刷新重试</p>
                                            </div>
                                            <div class="mask part-mask fadeIn" v-if="item.barcodeState !=0">{{item.barcodeState |toMaskText(qrCodeData.barcode)}}</div>
                                        </div>
                                    </div>
                                </mt-swipe-item>
                            </mt-swipe>
                        </div>
                        <p class="next" @click="nextPage" v-if="newCodes() && newCodes().length > 1">
                            <i class="iconfont icon-youjiantou icon-youjiatoutou-extra"></i>
                        </p>
                    </div>
                    <p class="indicators" v-if="newCodes() && newCodes().length > 1"><span>{{showIndex+1}}</span>/{{newCodes().length}}</p>
                    <div class="mask bg-white fadeIn" v-if="isTimerExpire" @click="refresh()">
                        <img src="~@/assets/images/order/icon_refresh@2x.png">
                        <p>请重新刷新获取核销码</p>
                    </div>
                    <!-- -->
                    <p class="warn">请凭手机短信或上方消费码/二维码验证使用</p>
            </div>
            <div class="write-off-records-wrapper" v-if="oldCodes.length > 0">
                    <div class="line-decorator">
                        <i class="circle l"></i>
                        <i class="circle r"></i>
                    </div>
                    <div class="write-off-records-content">
                        <p>核销记录</p>
                        <ul>
                            <li
                            v-if="+item.barcodeState === 1"
                            v-for="(item, index) in oldCodes"
                            >
                            <div><i class="icon-dot"></i></span></span><span class="text-middle-line">{{ item.barcode }}</span></div>
                            <div>{{
                                $$dateFormat(item.writeoffTime, 'YY.MM.DD hh:mm:ss')
                            }}</div>
                            </li>
                        </ul>
                    </div>
            </div>
       </template>
      </div>
  </div>
  <div v-if="isSticketDifData" class="exchange-code">   
    <p class="exchange-title">兑换码</p>
    <ul>
      <li v-for="item in exchangeCodes">
        <p class="code" ><span >兑换码：<em :id="item.barcode">{{item.barcode}}</em></span>
        <button class="tag-read copyText" :data-clipboard-text="item.barcode" @click="copyTextByClass">复制</button>
        </p>
      </li> 
    </ul>
    <p class="exchange-code-tips">*参照商品详情页使用说明进行兑换</p>
  </div>
 </div>
</template>   

<script>
import dayjs from "dayjs";
import { mapState } from "vuex";
import { Swipe, SwipeItem } from "mint-ui";
import { Msgbox } from "kf-component-vue";
import Clipboard from 'clipboard'
// import Qr from '@/plugins/qrCode'
import qrcode from "@/components/common/qrcode";
import codeModal from "@/components/newOrder/codeModal";
import { pushNrNs } from "@/plugins/jump";
import B_OrderDetail from "@/business/order/detail";
import { ORDER_BELONG_BUSI_ENUM } from "@/config";

let interval = "";
export default {
  inject: {
    reload: {},
    barcodeTrackParams: {
      default: null,
    },
  },
  props: {
    codeList: {
      type: Array,
      default() {
        return [];
      },
    },
    channelType: {
      // 订单类型
      type: Number,
      default: 1,
    },
    groupStaus: {
      // 拼团状态
      type: Number,
      default: 1,
    },
    isThirdParty: {
      // 三方门票
      type: Boolean,
      default: false,
    },
  },
  destroyed() {
    interval && window.clearInterval(interval);
  },
  data() {
    return {
      showIndex: 0,
      defaultIndex: 0,
      showingCode: {},
      isTimerExpire: false,
      timerCheckCountMax: 36,
      showSwipe: true,
    };
  },
  created() {
    this.showingCode = this.newCodes()[this.defaultIndex];
    this.launchCheckStatus();
  },
  mounted() {
    if (this.$refs.copyCode) {
      this.copyCodeBtn = new this.$$clipboard(this.$refs.copyCode);
    } 
  },
  filters: {
    toMaskText(val, code) {
      if (val == 1) {
        let str = code ? code.slice(0, 2) : "";
        let text = str === "CZ" ? "已验证" : "已发放";
        return text;
      } else if (val == 2) {
        return "已过期";
      } else {
        return "";
      }
    },
  },
  computed: {
    ...mapState(["order"]),
    isShowBarCode() {
      const { orderState, refundState } = this.order;
      return B_OrderDetail.isShowBarCodeModule(orderState, refundState);
    },
    barcodeUseEndTime() {
      return (
        this.showingCode &&
        dayjs(this.showingCode.barcodeUseEndTime).format("YYYY-MM-DD")
      );
    },
    oldCodes() {
      // 已核销的码信息
      const olds = this.codeList.filter((ele) => ele.barcodeState === 1);
      return olds;
    },
    exchangeCodes() {
      // 三方码信息
      const exchange = this.codeList.filter((ele) => ele.sticketDifData);
      return exchange;
    },
    isSticketDifData() {
      /** 是否展示三方码 与核销码展示互斥
                 展示条件：1.订单状态：待评价，已完成(orderState: 10.待支付 20.待使用 30.待评价 40.已完成 50.已取消 70.已过期(可选项)) 2.是否是异业导码：是 **/
      const status = [30, 40];
      return (
        status.includes(this.order.orderState) && this.exchangeCodes.length
      );
    },
  },
  methods: {
    refresh() {
      location.href = location.href;
    },
    // 未核销或退款驳回
    newCodes() {
      let codeList = this.order.barcodeList || [];
      // 未核销
      const news = codeList.filter((ele) => ele.barcodeState === 0);
      return news;
    },
    launchCheckStatus() {
      this.stopCheckStatus();
      if (
        this.showingCode &&
        this.showingCode.barcode &&
        this.showingCode.barcodeState == 0
      ) {
        this.checkBarcodeStatus(this.showingCode.barcode, this.order.orderId);
      }
    },
    stopCheckStatus() {
      interval && window.clearInterval(interval);
    },
    checkBarcodeStatus(code, orderId) {
      //等待扫码中，定时每5秒check核销码状态
      let timerCheckCount = this.timerCheckCountMax;
      let isFetch = true;
      interval = setInterval(async () => {
        console.log("count", timerCheckCount);
        if (timerCheckCount == 0) {
          clearInterval(interval);
          this.isTimerExpire = true;
        } else {
          timerCheckCount--;
          const param = {
            orderId: orderId,
            barcode: code,
            uid: this.$$cookie("uid"),
            skey: this.$$cookie("skey"),
          };
          if (isFetch) {
            isFetch = false;
            const code_res = await this.$store.dispatch(
              "queryBarcodeStatus",
              param
            );
            if (code_res) {
              isFetch = true;
              if (
                code_res.code == 1 &&
                code_res.data &&
                +code_res.data.barcodeState == 1
              ) {
                // 重新调用详情接口
                clearInterval(interval);
                const res = await this.$store.dispatch("getOrderDetail", {
                  uid: this.$$cookie("uid"),
                  skey: this.$$cookie("skey"),
                  orderCode: this.order.orderId,
                });
                this.showingCode = this.newCodes()[0];

                // TODO 解决二维码图片不同步刷新问题
                this.showSwipe = false;
                this.$nextTick(() => {
                  this.showSwipe = true;
                  this.launchCheckStatus();
                });

                if (this.newCodes().length === 0) {
                  this.toEvaluate();
                }
              }
            }
          }
        }
      }, 5000);
    },
    handleChange(index) {
      this.showIndex = index;
      this.showingCode = this.newCodes()[this.showIndex];
      this.launchCheckStatus();
    },
    prevPage() {
      this.$refs.swipe.prev();
      this.barcodeTrackParams && this.$$newTrackClick(this.barcodeTrackParams);
    },
    nextPage() {
      this.$refs.swipe.next();
      this.barcodeTrackParams && this.$$newTrackClick(this.barcodeTrackParams);
    },
    copyText() {
      let _this = this;
      let clipboard = _this.copyCodeBtn;
      clipboard.on("success", function (e) {
        _this.$$toast("复制成功");
        return;
      });
      clipboard.on("error", function (e) {
        window.prompt("复制失败，请手动复制", e.text);
      });
    },
    toEvaluate() {
      if (ORDER_BELONG_BUSI_ENUM.CZJ == this.order.businessType) {
        //21育儿 20 成长加
        let url = `//m.czj100.com/comment/publish2product?id=${this.order.spuId}&orderId=${this.order.orderId}&cmd=share&sharetype=0&refresh=no`;
        //TODO 登录态问题待处理
        if (this.$$isHZWApp() || this.$$isCZJApp()) {
          url = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
            url
          )}&uid=${this.$$cookie("uid")}&skey=${this.$$cookie("skey")}`;
        }

        location.href = url;
      } else {
        pushNrNs({
          // 新写评价入口
          name: "evaluate",
          query: {
            orderCode: this.order.orderId,
            ht: "add",
          },
        });
      }
    },
    copyTextByClass() {
       const _this = this;
       var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
           _this.$$toast("复制成功");
          // 释放内存
          clipboard.destroy()
          return;
        })
        clipboard.on('error', e => {
          // 不支持复制
          window.prompt("复制失败，请手动复制", e.text);
          // 释放内存
          clipboard.destroy()
        })
    }
  },
  components: {
    "mt-swipe": Swipe,
    "mt-swipe-item": SwipeItem,
    Msgbox,
    codeModal,
    qrcode,
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/mixin";

.kfcv-msgbox .kfcv-msgbox-core {
  width: 5.6rem !important;
}
.kfcv-msgbox .kfcv-msgbox-content {
  font-size: 0.28rem;
  color: #666666;
  padding: 0.46rem 0.2rem 0.3rem !important;
}

.copyText {
  color: #ff5900;
  font-size: rem(20px);

  margin-left: rem(19px);
  border: #ff5900 rem(1px) solid;
  border-radius: rem(5px);
  display: flex;
  justify-content: center;
  padding: rem(2px);
}

.icon-youjiatoutou-extra {
  font-size: rem(48px);
  color: #262626 !important;
}

.icon-zuojiatoutou-extra {
  display: inline-block; //!!
  font-size: rem(48px);
  color: #262626 !important;
  transform: rotate(180deg);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
}

.mask.part-mask {
  font-weight: bold;
  color: #000;
}
.mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.7);
  color: #999;
  font-size: rem(32px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    padding-top: rem(40px);
    font-size: rem(30px);
    color: #666666;
  }
  img {
    width: rem(60px);
    height: rem(60px);
  }
}
.swipe-main .mask {
  top: 0;
}
.mask.bg-white {
  background: #fff;
}

.no-code {
  background-color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: rem(190px);
    height: rem(190px);
  }
  .no-code-tip {
    padding-top: rem(30px);
    font-size: rem(30px);
    color: #999;
  }
}
.swipe-item-ui {
  height: 100%;
}

.code-barcode {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  height: 100%;
  text-align: center;
  & > img {
    height: rem(308px);
  }
}

.swipe-layout {
  background-color: #fff;
  height: rem(360px);
  display: flex;
  align-items: center;
  justify-content: center;
  .swipe-main {
    width: 70%;
    height: 100%;
  }
  & > p {
    width: 10%;
    text-align: center;
    i {
      color: #9b9c9b;
    }
  }
}
.indicators {
  background-color: #fff;
  text-align: center;
  color: #9b9c9b;
  span {
    color: #121112;
  }
}
</style>
<style lang="scss" scoped src="./style.scss"></style>
